export const FINANCIAL_DASHBOARD_ROUTE = '/v2/analytics/financial-dashboard';
export const FINANCIAL_DASHBOARD_NEW_ROUTE = '/v2/analytics/financial-dashboard-new';
